import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { NAV_LINKS, CONTACT, PRODUCTS } from "../../data/siteData";

export const Footer = () => (
  <footer className="noise-overlay bg-[#0A0A0A] text-white" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="inline-block bg-white p-3" data-testid="footer-logo-wrap">
            <img src="/assets/celestraone-logo.png" alt="CelestraOne Ventures" className="h-16 w-auto" />
          </div>
          <p className="mt-4 font-display text-2xl font-bold tracking-tight" data-testid="footer-brand-name">
            CelestraOne Ventures <span className="text-[#D40000]">Pvt. Ltd.</span>
          </p>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-gray-400">
            CelestraOneVentures Pvt. Ltd. — granite, marble and dolomite from our own quarries and mines,
            processed in-house and supplied across India and international markets.
          </p>
        </div>
        <div className="md:col-span-3">
          <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-[#D40000]">Explore</h4>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-gray-300 transition-colors hover:text-white"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-[#D40000]">Products</h4>
          <ul className="mt-5 space-y-3">
            {PRODUCTS.map((p) => (
              <li key={p.key}>
                <Link
                  to={`/products?stone=${p.key}`}
                  data-testid={`footer-product-${p.key}`}
                  className="text-sm text-gray-300 transition-colors hover:text-white"
                >
                  {p.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-[#D40000]">Reach Us</h4>
          <ul className="mt-5 space-y-3 text-sm text-gray-300">
            <li className="flex items-start gap-2">
              <Phone size={14} className="mt-1 shrink-0" />
              <a href={CONTACT.phoneHref} data-testid="footer-phone" className="hover:text-white">{CONTACT.phoneDisplay}</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail size={14} className="mt-1 shrink-0" />
              <span data-testid="footer-email">{CONTACT.email}</span>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={14} className="mt-1 shrink-0" />
              <span data-testid="footer-address">{CONTACT.address}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-14 border-t border-white/10 pt-6 text-xs text-gray-500">
        © {new Date().getFullYear()} CelestraOneVentures Pvt. Ltd. All rights reserved.
      </div>
    </div>
  </footer>
);
